import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ProductCardComponent } from './main-content-components/product-card/product-card.component';
import { RecentVideosComponent } from './main-content-components/recent-videos/recent-videos.component';
import { FavoritesComponent } from './main-content-components/favorites/favorites.component';
import { RecentDocumentsComponent } from './main-content-components/recent-documents/recent-documents.component';

@Component({
  selector: 'app-main-content',
  imports: [CommonModule,
    ProductCardComponent,
    // VideoCountComponent,
    RecentVideosComponent,
    FavoritesComponent,
    RecentDocumentsComponent,],
  templateUrl: './main-content.component.html',
  styleUrl: './main-content.component.scss'
})
export class MainContentComponent {

}
